var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        size: "lg",
        title: "Settings",
        centered: "",
        "dialog-class": "settings-modal-dialog",
        "cancel-variant": "light",
      },
      on: {
        hide: _vm.closeHandler,
        ok: _vm.saveCompressSettings,
        show: _vm.fetchCompressSettings,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-ok",
          fn: function () {
            return [_vm._v("\n    Save\n  ")]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-tabs",
        [
          _c("b-tab", { attrs: { title: "General" } }, [
            _vm.isCompressSettingsFetching
              ? _c(
                  "div",
                  {
                    staticClass:
                      "justify-content-center align-items-center loading settings-loading",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "spinner-border text-primary",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-3" }, [
              _c("label", { staticClass: "general-settings-label" }, [
                _vm._v("\n          Grid View Tile Size\n          "),
                _c(
                  "a",
                  {
                    staticClass: "info-tooltip video-compress-quality-tooltip",
                    attrs: {
                      href: "#",
                      "data-toggle": "tooltip",
                      title: "Controls thumbnail size in grid view.",
                    },
                  },
                  [_c("InfoIcon", { attrs: { width: 10, height: 10 } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-items-center gap-2" },
                [
                  _c("Grid3x3Icon", { attrs: { width: 24, height: 24 } }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass:
                      "form-control-range flex-grow-1 tile-size-slider",
                    style: { "--tile-size-pct": `${_vm.thumbSize}%` },
                    attrs: { type: "range", min: "0", max: "100", step: "1" },
                    domProps: { value: _vm.thumbSize },
                    on: { input: _vm.onThumbSizeInput },
                  }),
                  _vm._v(" "),
                  _c("LayoutGridIcon", { attrs: { width: 24, height: 24 } }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-3" }, [
              _c("label", { staticClass: "general-settings-label" }, [
                _vm._v("\n          Video Compress Quality\n          "),
                _c(
                  "a",
                  {
                    staticClass: "info-tooltip video-compress-quality-tooltip",
                    attrs: {
                      href: "#",
                      "data-toggle": "tooltip",
                      title:
                        "Note that lower values correspond to higher bitrates, and hence produce higher quality videos.",
                    },
                  },
                  [_c("InfoIcon", { attrs: { width: 10, height: 10 } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  staticClass: "form-control",
                  domProps: {
                    value:
                      _vm.compressSettingsData[
                        _vm.SETTINGS_MODAL_FIELDS_NAME.quality_compress_video
                      ],
                  },
                  on: {
                    change: function ($event) {
                      return _vm.filedHandler(
                        _vm.SETTINGS_MODAL_FIELDS_NAME.quality_compress_video,
                        $event.target.value
                      )
                    },
                  },
                },
                _vm._l(_vm.compressQuality, function (quality) {
                  return _c(
                    "option",
                    { key: quality, domProps: { value: quality } },
                    [
                      _vm._v(
                        "\n            " + _vm._s(quality) + "\n          "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "general-settings-label" }, [
                _vm._v("\n          Image Compress Max Size\n          "),
                _c(
                  "a",
                  {
                    staticClass: "info-tooltip image-compress-max-size-tooltip",
                    attrs: {
                      href: "#",
                      "data-toggle": "tooltip",
                      title:
                        "Max resolution value for the image. If the original image resolution is higher than this value, the image will be resized with this value.",
                    },
                  },
                  [_c("InfoIcon", { attrs: { width: 10, height: 10 } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: {
                  value:
                    _vm.compressSettingsData[
                      _vm.SETTINGS_MODAL_FIELDS_NAME
                        .image_compress_max_size_webp
                    ],
                },
                on: {
                  input: function ($event) {
                    return _vm.filedHandler(
                      _vm.SETTINGS_MODAL_FIELDS_NAME
                        .image_compress_max_size_webp,
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "general-settings-label" }, [
                _vm._v("\n          Image Compress Quality\n          "),
                _c(
                  "a",
                  {
                    staticClass: "info-tooltip image-compress-quality-tooltip",
                    attrs: {
                      href: "#",
                      "data-toggle": "tooltip",
                      title:
                        "Image compression level. Quality is 1 (lowest image quality and highest compression) to 100 (best quality but least effective compression). The default is to use the estimated quality of your input image if it can be determined, otherwise 92.",
                    },
                  },
                  [_c("InfoIcon", { attrs: { width: 10, height: 10 } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: {
                  value:
                    _vm.compressSettingsData[
                      _vm.SETTINGS_MODAL_FIELDS_NAME.image_compress_quality
                    ],
                },
                on: {
                  input: function ($event) {
                    return _vm.filedHandler(
                      _vm.SETTINGS_MODAL_FIELDS_NAME.image_compress_quality,
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { staticClass: "general-settings-label" }, [
                _vm._v("\n          Video Convert Setting\n        "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        value: "on",
                        "unchecked-value": "off",
                        checked:
                          _vm.compressSettingsData[
                            _vm.SETTINGS_MODAL_FIELDS_NAME
                              .when_convert_delete_original_file
                          ],
                      },
                      on: {
                        change: function ($event) {
                          return _vm.filedHandler(
                            _vm.SETTINGS_MODAL_FIELDS_NAME
                              .when_convert_delete_original_file,
                            $event
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "general-settings-label" }, [
                        _vm._v("When converting, delete original file"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("b-tab", { attrs: { title: "Advanced" } }, [
            _c(
              "div",
              { staticClass: "c-settings-advanced d-flex flex-column mt-3" },
              [
                _c("p", { staticClass: "general-settings-label mb-2" }, [
                  _vm._v(
                    "\n          Maintenance actions. Each runs once and notifies you on completion.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "mt-2",
                    attrs: { disabled: _vm.isReindexing, variant: "light" },
                    on: { click: _vm.reindexHandler },
                  },
                  [
                    _vm.isReindexing
                      ? _c("b-spinner", {
                          attrs: { small: "", label: "Spinning" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("RefreshCwIcon", {
                      staticClass: "mb-1",
                      attrs: { width: 16, height: 16 },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "general-settings-label" }, [
                      _vm._v("\n            Reindex Files\n          "),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "mt-2",
                    attrs: { disabled: _vm.isGenerating, variant: "light" },
                    on: { click: _vm.generateThumbnailHandler },
                  },
                  [
                    _vm.isGenerating
                      ? _c("b-spinner", {
                          attrs: { small: "", label: "Spinning" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ImageIcon", {
                      staticClass: "mb-1",
                      attrs: { width: 16, height: 16 },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "general-settings-label" }, [
                      _vm._v("\n            Generate Thumbnails\n          "),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "mt-2",
                    attrs: { disabled: _vm.isRegenerating, variant: "light" },
                    on: { click: _vm.reGenerateThumbnailHandler },
                  },
                  [
                    _vm.isRegenerating
                      ? _c("b-spinner", {
                          attrs: { small: "", label: "Spinning" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("RotateCcwIcon", {
                      staticClass: "mb-1",
                      attrs: { width: 16, height: 16 },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "general-settings-label" }, [
                      _vm._v(
                        "\n            Re-generate Thumbnails\n          "
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }